export default __webpack_public_path__ + "static/2025-img-articolo-febbraio1-65e3b5800aa794be5d1fdc8cf68956a5.jpg";